import type React from 'react';

import styles from './styles';

import { DescriptionTitle } from '@cobliteam/base-components';

interface CircleDividerProps {
  className?: string;
}

const CircleDivider: React.FC<CircleDividerProps> = ({ className = '' }) => {
  return (
    <DescriptionTitle className={`${styles.divider} ${className}`}>
      •
    </DescriptionTitle>
  );
};

export default CircleDivider;
